import React, { ChangeEvent, Component } from "react";
import "./OwInput.scss";
import * as _ from "lodash-es";
import ISupplierModel from "../../../models/ISupplierModel";
import SupplierService from "../../../services/SupplierService";
import UIService from "../../../services/UIService";
import IOwInputProps from "./IOwInputProps";
import InputMask from "react-input-mask";
import { IntlShape } from "react-intl";
import { UseFormRegisterReturn } from "react-hook-form";

type Props = IOwInputProps & {
    id?: string;
    className?: string;
    placeholder?: string;
    fn: any;
    onKeyDownFn?: (e: any) => void;
    onClickFn?: (e: any) => void;
    disabled?: boolean;
    value?: any;
    name: string;
    ref?: React.RefObject<any>;
    type?: "number" | "email" | "password" | "text" | "tel" | "radio";
    autoComplete?: boolean | string;
    isRequired?: boolean;
    minLength?: number;
    maxLength?: number;
    isSmall?: boolean;
    supplierModel?: any;
    isSupplierVendorOverride?: boolean;
    min?: number;
    max?: number;
    step?: number | "any";
    showStep?: boolean;
    tabIndex?: number;
    disableKeyUp?: boolean;
    editMode?: boolean;
    // @deprecated - Use OwCheckbox instead.
    checked?: boolean;
    returnZero?: boolean;
    title?: string;
    maskedInput?: boolean;
    mask?: string;
    maskChar?: string;
    defaultClassName?: string;
    alwaysShowMask?: boolean;
    enableDebounce?: boolean;
    disablePrecisionCheck?: boolean;
    autoFocus?: boolean;
    onWheelFn?: (e: any) => void;
    testId?: string;
    intl: IntlShape;
    register?: UseFormRegisterReturn<any>;
};

type State = {
    isInitialLoad: boolean;
    indicatorBarInterval?: any;
    indicatorBarPercentage: number;
};

class OwInput extends Component<Props, State> {
    enableVisualDebouce = false;

    static defaultProps = {
        placeholder: "",
    };

    readonly state: State = {
        isInitialLoad: true,
        indicatorBarPercentage: 100,
    };

    fn = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        if (this.props.maxLength) {
            if (value.toString().length > this.props.maxLength) {
                return;
            }
        }

        if (_.isNil(value) && this.props.returnZero) {
            e.target.value = 0;
        }

        // Don't convert to Number during typing as it strips incomplete decimals like "1."
        // The HTML5 number input will handle the conversion automatically
        // if (this.props.type === "number") {
        //     if (value > 0) {
        //         e.target.value = Number(e.target.value);
        //     }
        // }

        this.props.fn(e);
    };

    setIndicatorWidth = () => {
        const { indicatorBarPercentage, indicatorBarInterval } = this.state;

        let newBarPercentage = 0;

        if (indicatorBarPercentage > 10) {
            newBarPercentage = indicatorBarPercentage - 10;
        } else {
            clearInterval(indicatorBarInterval);
        }

        this.setState({
            indicatorBarPercentage: newBarPercentage,
        });
    };

    onBlur = (e: any) => {
        UIService.iOSKeyboardOpenFix();
    };

    render() {
        let dashedPlaceholder = this.props.placeholder!.replace(/ /g, "_");

        let placeholder = this.props.placeholder!;

        if (this.props.isSupplierVendorOverride && !_.isNil(this.props.supplierModel.vendor_name_override)) {
            placeholder = placeholder.replace(/vendor/g, this.props.supplierModel.vendor_name_override);
            dashedPlaceholder = dashedPlaceholder.replace(/vendor/g, this.props.supplierModel.vendor_name_override);
        }

        if (placeholder.length) {
            const messageProps: any = {
                id: dashedPlaceholder,
                propName: "",
            };

            placeholder = this.props.intl.formatMessage(messageProps);
        }

        let type = "text";

        if (!_.isNil(this.props.type)) {
            type = this.props.type;
        }

        let autoComplete: string | boolean = "on";

        if (!this.props.autoComplete) {
            autoComplete = "off";
        }

        if (this.props.autoComplete) {
            autoComplete = this.props.autoComplete;
        }

        let className = this.props.className || "";

        if (this.props.isSmall) {
            className += " form-control-sm";
        }

        let errorState = false;

        if (this.props.isRequired) {
            if (this.props.minLength) {
                if (this.props.value && this.props.value.length < this.props.minLength) {
                    errorState = true;
                }
            } else {
                if (_.isNil(this.props.value) || !this.props.value.length) {
                    errorState = true;
                }
            }
        }

        let step: any = this.props.step;
        let min = this.props.min;
        let max: number | undefined = undefined;

        if (this.props.max) {
            max = this.props.max;
        }

        if (this.props.showStep) {
            step = this.props.step || "any";
            min = !_.isNil(this.props.min) ? this.props.min : 1;
        }

        let defaultClassName = " form-control form-control-sm ";

        if (this.props.type === "radio") {
            defaultClassName = " ";
        }

        if (this.props.defaultClassName) {
            defaultClassName = ` ${this.props.defaultClassName} `;
        }

        const compiledClassname = className + defaultClassName + (errorState ? "is-invalid alert-danger" : "");

        const value = !_.isNil(this.props.value) ? this.props.value : "";

        if (this.props.name.indexOf("qty") >= 0) {
            // console.log("qty", this.props.name);
            const supplier: ISupplierModel = this.props.supplierModel || SupplierService.getLocalSupplierDataFn();

            // if (supplier && !this.props.disablePrecisionCheck) {
            //     if (!_.isNil(supplier.qty_precision) && !_.isNil(value)) {
            //         if (supplier.qty_precision === 0) {
            //             value = parseFloat(value).toFixed(supplier.qty_precision);
            //         }
            //     }
            //     // if (!_.isNil(supplier.qty_precision)) {
            //     //     step = supplier.qty_precision;
            //     // }
            // }
        }

        const addlProps: any = {};

        if (this.props.type === "number") {
            // Use "decimal" inputMode when step indicates decimal precision is needed
            const allowsDecimals = this.props.step && this.props.step !== "any" && this.props.step < 1;

            if (allowsDecimals) {
                addlProps.inputMode = "decimal"; // Shows decimal point on mobile keyboards
                // Use decimal-friendly pattern that allows optional decimal point
                addlProps.pattern = "[0-9]*\\.?[0-9]*";
            } else {
                addlProps.inputMode = "numeric";
                addlProps.pattern = "[0-9]*";
            }
            addlProps["disable-autocomplete"] = "true";
        }

        let editModeView = (
            <input
                {...this.props.register}
                data-testid={this.props.testId || this.props.name}
                id={this.props.id}
                autoFocus={this.props.autoFocus}
                title={this.props.title}
                ref={this.props.ref}
                type={type}
                className={compiledClassname}
                name={this.props.name}
                aria-label={this.props.name}
                placeholder={placeholder}
                onClick={this.props.onClickFn}
                onKeyUp={(e: any) => {
                    if (this.props.disableKeyUp) {
                        return null;
                    }
                    this.fn(e);
                }}
                onKeyDown={this.props.onKeyDownFn}
                onChange={(e: any) => {
                    this.fn(e);
                }}
                onBlur={this.onBlur}
                disabled={this.props.disabled}
                value={value}
                checked={this.props.checked}
                autoComplete={autoComplete}
                required={this.props.isRequired}
                minLength={this.props.minLength}
                maxLength={this.props.maxLength}
                min={min}
                max={max}
                step={step}
                tabIndex={this.props.tabIndex}
                onWheel={this.props.onWheelFn}
                data-lpignore="true"
                {...addlProps}
            />
        );

        if (this.props.maskedInput && this.props.mask) {
            editModeView = (
                <InputMask
                    data-testid={this.props.testId}
                    id={this.props.id}
                    mask={this.props.mask}
                    maskChar={this.props.maskChar}
                    alwaysShowMask={this.props.alwaysShowMask}
                    title={this.props.title}
                    ref={this.props.ref}
                    type={type}
                    className={compiledClassname}
                    name={this.props.name}
                    placeholder={placeholder}
                    onKeyUp={(e: any) => {
                        if (this.props.disableKeyUp) {
                            return null;
                        }

                        this.fn(e);
                    }}
                    onKeyDown={this.props.onKeyDownFn}
                    onChange={(e: any) => {
                        this.fn(e);
                    }}
                    disabled={this.props.disabled}
                    value={value}
                    checked={this.props.checked}
                    autoComplete={autoComplete}
                    required={this.props.isRequired}
                    minLength={this.props.minLength}
                    maxLength={this.props.maxLength}
                    min={min}
                    max={max}
                    step={step}
                    tabIndex={this.props.tabIndex}
                    onWheel={this.props.onWheelFn}
                    {...addlProps}
                />
            );
        }

        const displayValue = this.props.value;

        const widthPerc = this.state.indicatorBarPercentage;

        let height = "3px";

        if (!this.enableVisualDebouce) {
            height = "0px";
        }

        if (this.props.editMode || _.isNil(this.props.editMode)) {
            if (this.props.appendText && this.props.prependText) {
                return (
                    <div className={"input-group input-group-sm"}>
                        <div className={"input-group-prepend"}>
                            <span className={"input-group-text"}>{this.props.prependText}</span>
                        </div>
                        {editModeView}
                        <div className={"input-group-append"}>
                            <span className={"input-group-text"}>{this.props.appendText}</span>
                        </div>
                    </div>
                );
            } else if (this.props.appendText) {
                return (
                    <div className={"input-group input-group-sm"}>
                        {editModeView}
                        <span className={"input-group-text"}>{this.props.appendText}</span>
                    </div>
                );
            } else if (this.props.prependText) {
                return (
                    <div className={"input-group input-group-sm"}>
                        <div className={"input-group-prepend"}>
                            <span className={"input-group-text"}>{this.props.prependText}</span>
                        </div>
                        {editModeView}
                    </div>
                );
            } else {
                return (
                    <>
                        {this.enableVisualDebouce ? (
                            <div
                                className={"faded-orange-bg position-absolute"}
                                style={{ width: `${widthPerc}%`, height: `${height}` }}></div>
                        ) : null}
                        {editModeView}
                    </>
                );
            }
        } else {
            return displayValue || "";
        }
    }
}

export default OwInput;
